/**
 * Listing Content Element Visibility Rules
 * 
 * Controls visibility of listing content elements (LISTING_HERO experiment).
 */

import { AllowedExperimentKey } from '@tenants/types';
import { ExperimentElement, type VisibilityRule } from '../../types';

/**
 * Listing content element visibility rules
 * 
 * Logic:
 * - Open House Card: New standalone card component (v2 redesign)
 *   - Only show when LISTING_HERO experiment is active (both desktop and mobile)
 *   - Legacy has open house info built into hero content, so no separate card needed
 */
export const contentRules: Partial<Record<ExperimentElement, VisibilityRule>> = {
  [ExperimentElement.OPEN_HOUSE_CARD]: {
    showWhen: {
      experiments: [AllowedExperimentKey.LISTING_HERO],
    },
  },
};
